import { useEffect, useState } from 'react'
import { Navbar } from '../../../components/layout/Navbar'
import PaymentDetails from './PaymentDetails'
import PaymentMethod from './PaymentMethod'
import { Button } from '../../../components/ui/Button'
import InitialPaymentSuccess from './InitialPaymentSuccess'
import { useNavigate } from 'react-router-dom'
import { InitialPaymentDetails } from '@/types/management.types'

export const InitialPaymentPageContent = () => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    'transfer' | 'deposit'
  >('transfer')

  const [paymentDetails, setPaymentDetails] =
    useState<InitialPaymentDetails | null>(null)

  const [success, setSuccess] = useState<boolean>(false)

  const navigate = useNavigate()

  const handlePaymentMethodChange = (method: 'transfer' | 'deposit') => {
    setSelectedPaymentMethod(method)
    console.log('Método de pago seleccionado:', method)
  }

  function handleCancel(): void {
    navigate('/proposal-review')
  }

  function handleConfirm(): void {
    setSuccess(true)
    console.log('Pago inicial confirmado', selectedPaymentMethod)
  }

  useEffect(() => {
    setPaymentDetails({
      customerName: 'Laura',
      customerLastName: 'Millan',
      quotedUnits: 1,
      amountToPay: 203616.18,
      reference: 'Pago inicial - Cotización',
      paymentDate: '22/Mayo/2025',
      quoteId: 'ID#2000540',
    })
  }, [])

  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header - Solo gradiente */}
        <div
          className="h-48 flex items-center justify-center relative"
          style={{
            background:
              'linear-gradient(180deg, #1789CF 0%, #02298A 84.79%, #021B79 100%)',
            minHeight: '192px',
          }}
        >
          {/* Logo centrado - más grande */}
          <div className="text-center z-10">
            <img
              src="/assets/olr-logo.png"
              alt="OLR Leasing"
              className="filter brightness-0 invert w-40 h-auto mx-auto"
            />
          </div>
        </div>

        {/* Mobile Form section - menos padding top */}
        <div className="flex-1 bg-white flex items-start justify-center pt-8 px-6 pb-6">
          <div className="w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
              Tu cotización está lista
            </h2>

            <p className="text-gray-600 justify-center text-center wordwrap mb-6">
              Hemos revisado tu información y generado una propuesta con las
              condiciones de arrendamiento. Por favor, revísala cuidadosamente y
              elige cómo deseas continuar.
            </p>
            <div className="w-full max-w-6xl p-8 ">
              {/* Aquí va el contenido de la página */}
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex min-h-screen flex-col">
        <Navbar />

        {/* Main content with bg-flow */}
        <div
          className="flex-1 flex flex-col items-center justify-start py-1 px-4"
          style={{
            backgroundImage: 'url(/assets/bg-flow.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {success ? (
            <div className="flex-1 flex items-center justify-center w-full">
              <InitialPaymentSuccess onFinalize={() => setSuccess(false)} />
            </div>
          ) : (
            <>
              <div className="bg-white px-8 rounded-lg max-w-3xl w-full mx-4">
                <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
                  Haz tu pago inicial
                </h2>

                <p className="text-gray-900  mb-8 justify-center text-center wordwrap">
                  Para continuar con el proceso de arrendamiento, es necesario
                  realizar el pago inicial correspondiente a tu plan
                  seleccionado. Una vez confirmado el pago, te contactaremos
                  para agendar la firma del contrato.
                </p>
              </div>

              <div className="w-full max-w-6xl px-8 pb-8">
                <PaymentDetails details={paymentDetails} />
              </div>
              <div className="bg-white rounded-lg">
                <PaymentMethod
                  onPaymentMethodChange={handlePaymentMethodChange}
                  defaultMethod="transfer"
                  beneficiaryName="OLR Leasing S.A. de C.V."
                  clabe="646180000000000000"
                />
              </div>
              <div className="flex justify-center gap-4 mt-12">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleCancel}
                  className="px-8 py-3 min-w-[260px]"
                >
                  Regresar
                </Button>

                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleConfirm}
                  className="px-8 py-3 min-w-[260px]"
                >
                  Confirmar y continuar
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}
